import { addWhitelistEntry, updateWhitelistEntry } from '../../../actions/email2sms/whitelist';
import { WhitelistFormSubmit } from './whitelist.form';

const submitForm: WhitelistFormSubmit = (values, dispatch) => {
  dispatch(values.id ? updateWhitelistEntry(values) : addWhitelistEntry(values));
}
export default submitForm;
